<div class="o-step-indicator__current-step-title">
    <span class="h-visually-hidden"> Current step is: </span>
    {{ item.title }}
    <span class="h-visually-hidden"> (Click to show all step titles) </span>
    <span *ngIf="item.icon" class="o-step-indicator__current-step-state-icon">
        <ng-container *ngTemplateOutlet="item.icon"> </ng-container>
    </span>
</div>
